import SectionHeading from './SectionHeading';
import { antiLostTips } from '@/mocks/homeData';

export default function AntiLost() {
  return (
    <section id="antilost" className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="mb-10 md:mb-14 max-w-3xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-3 py-1 text-xs font-medium tracking-wide text-primary-200">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              防走失指南
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold leading-snug text-background-50">
              学会「防走失」，比记住一个地址更重要
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-background-50/70">
              地址会变，习惯不会。下面这些做法能帮你在入口更替时依然从容，把「找得到的线索」牢牢握在自己手里。
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {antiLostTips.map((tip, idx) => (
              <article
                key={tip.title}
                className="rounded-lg border border-background-50/10 bg-background-50/5 p-5 md:p-6 transition-colors hover:border-primary-400/50"
              >
                <div className="flex items-center justify-between">
                  <div className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-500/20 text-primary-200">
                    <i className={`${tip.icon} text-xl`}></i>
                  </div>
                  <span className="font-heading text-2xl font-bold text-background-50/15">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-background-50">
                  {tip.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-background-50/70">{tip.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}